import React from 'react';

import {Error404} from 'jpm-adr-pattern-library';

import '../../styles/components/Page404.scss'

const Page404 = ()=>{
  const focusInput = component =>{
    if(component){
      component.focus()
    }
  };
  return(
    <section className="Page404-wrapper">
      <Error404
        action={
          (
            <a
              href="https://markets.jpmorgan.com"
              ref={focusInput}
              tabIndex="0"
              className="Error404__Button"
              Aria-label="Return to J.P. MORGAN MARKETS HOME PAGE"
            >
              Return to J.P. MORGAN MARKETS HOME PAGE
            </a>
          )
        }
      />
    </section>
  )
}

export default Page404;
